import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { AbvPipeDayList } from './AbvPipeDayList';

export const AbvPipeDayGrpDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'pipeDayGrpItemTab', label: 'Pipeline Days', content: <AbvPipeDayList pipeDayGrpId={entityObj.id}/> },
  ]

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}